// COPIED from ptc-core web/src/components/links/realLinkProps.ts @ 822453f (fleet real links v1, 2026-10-29). Verbatim.
// Conformance: realLink.test.tsx + tools/links/real-links-sweep.test.mjs.
/**
 * The real-link click rules (fleet ruling 2026-10-29), apart from the components so they can be spread on any
 * anchor-rendering element (Fluent's `<Button as="a">`, `<MenuItemLink>`). Portable: no router import.
 */
import type { MouseEvent } from 'react';

export type NavigateFn = (href: string) => void;

/** True for a click the app should handle in-page: primary button, no modifier, not opening elsewhere. */
export function isPlainLeftClick(e: MouseEvent<HTMLElement>): boolean {
  if (e.defaultPrevented || e.button !== 0) return false;
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return false;
  const target = (e.currentTarget as HTMLAnchorElement).getAttribute('target');
  return !target || target === '_self';
}

export interface RealLinkOptions {
  /** The app's in-page navigation. Omit it and a plain click follows the href natively. */
  navigate?: NavigateFn;
  /** Runs however the link is followed (plain, modified or middle click, or Enter). */
  onFollow?: () => void;
  /** The caller's own click handler; it runs first and may `preventDefault()` to cancel. */
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
}

/**
 * The props that make any anchor-rendering element a real link: spread them on an `<a>`, on Fluent's
 * `<Button as="a">` or on `<MenuItemLink>`.
 */
export function realLinkProps(href: string, { navigate, onFollow, onClick }: RealLinkOptions = {}) {
  return {
    href,
    onClick: (e: MouseEvent<HTMLAnchorElement>) => {
      onClick?.(e);
      if (e.defaultPrevented) return;
      onFollow?.();
      if (navigate && isPlainLeftClick(e)) {
        e.preventDefault();
        // programmatic-nav: the in-page half of a real <a href>; modified clicks never reach here.
        navigate(href);
      }
    },
    onAuxClick: (e: MouseEvent<HTMLAnchorElement>) => {
      if (e.button === 1) onFollow?.();
    },
  };
}
